import {Component} from '@angular/core';

@Component({
  templateUrl: '500.component.html'
})
export class P500Component {

  constructor() {
  }

}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/pages/500.component.ts